import {
  getUsers,
  createUser,
  deleteUserFromProject,
  getPassword,
  updateUser
} from '../services/napi';
import { FETCH_USERS_SUCCESS, GENERATE_USERS_PASSWORD_SUCCESS } from '../constant/actionType';

export function getAllUsers() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getUsers(projectId);
    dispatch({ data: response.data.users, type: FETCH_USERS_SUCCESS });
  };
}

export function createNewUserAction(fullName, email, role, password, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const name = fullName.split(' ')[0] || '';
    const surname = fullName.split(' ')[1] || '';
    const data = { email, name, password, role, surname };
    await createUser(projectId, data);
    onSuccess();
  };
}

export function updateUserAction(fullName, email, role, password, id, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const [name, surname] = fullName.split(' ');
    const data = { email, name, password, role, surname };
    await updateUser(projectId, id, data);
    onSuccess();
  };
}

export function deleteUserAction(userId, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await deleteUserFromProject(projectId, userId);
    onSuccess();
  };
}

export function getGeneratedPassword(onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getPassword(projectId);
    onSuccess(response.data.generatedPassword);
    dispatch({
      data: response.data.generatePassword,
      type: GENERATE_USERS_PASSWORD_SUCCESS
    });
  };
}
